import { getChallenges } from '../../../exam-service/functions';

import { ChampionshipsEndpoints } from '../../../../endpoint';
import { ChampionshipService } from '../../..';

import * as Models from '../../../../models';

export interface GetChampionshipChallengesParams {
  championshipId: Models.ChampionshipId;
  studentId: Models.UserId;
}

export const getChampionshipChallenges = async (
  params: GetChampionshipChallengesParams,
): Promise<Models.Challenge[]> => {
  const { championshipId, studentId } = params;
  const championship = await ChampionshipsEndpoints.getById(championshipId);
  const challengeTokens = championship.challenges;
  const orderDateStart = Models.ChallengeOrderDateStart.Asc;

  const challenges = await getChallenges({ challengeTokens, orderDateStart });

  const fullParticipantStats = await ChampionshipService.getParticipantInfo({ championshipId, studentId });
  const listOfCompletedChallengesTokens = fullParticipantStats.completedChallengeTokens;

  return challenges.resources.map(challenge => ({
    ...challenge,
    isParticipated: listOfCompletedChallengesTokens.includes(challenge.token!),
  }));
};
